import { computed, ref, type Ref } from 'vue';

export type AppNotificationType = 'info' | 'success' | 'error' | 'warning';

export interface AppNotificationItem {
  id: string;
  message: string;
  type: AppNotificationType;
  durationMs: number;
}

const DEFAULT_DURATION_MS = 6000;
const MAX_VISIBLE = 6;

const notificationsList: Ref<AppNotificationItem[]> = ref([]);

/** Oldest first so the stack grows upward with the newest toast nearest the bottom edge. */
export const displayNotifications = computed(() =>
  notificationsList.value.slice(-MAX_VISIBLE)
);

export function dismissToast(id: string): void {
  const idx = notificationsList.value.findIndex((n) => n.id === id);
  if (idx !== -1) {
    notificationsList.value.splice(idx, 1);
  }
}

export function clearToasts(): void {
  notificationsList.value = [];
}

export function notify(
  message: string,
  options?: { type?: AppNotificationType; durationMs?: number }
): string {
  const id = crypto.randomUUID();
  notificationsList.value.push({
    id,
    message,
    type: options?.type ?? 'info',
    durationMs: options?.durationMs ?? DEFAULT_DURATION_MS,
  });
  return id;
}
